import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private currentOverlay = signal<HTMLElement | null>(null);
  private currentOpenMode: 'click' | 'hover' | null = null;
  private registry = new Map<string, HTMLElement>();

  register(id: string, element: HTMLElement): void {
    this.registry.set(id, element);
  }

  unregister(id: string): void {
    const element = this.registry.get(id);
    if (element && this.currentOverlay() === element) {
      this.currentOverlay.set(null);
    }
    this.registry.delete(id);
  }

  get(id: string): HTMLElement | null {
    return this.registry.get(id) ?? null;
  }

  registerOpen(element: HTMLElement, mode: 'click' | 'hover' = 'click'): void {
    const current = this.currentOverlay();

    // Don't close a click-opened overlay when a hover overlay wants to open.
    // The hover overlay will still show, but won't replace the tracked current.
    if (mode === 'hover' && this.currentOpenMode === 'click' && current) {
      return;
    }

    if (current && current !== element) {
      current.hidePopover();
    }
    this.currentOverlay.set(element);
    this.currentOpenMode = mode;
  }

  registerClose(element: HTMLElement): void {
    if (this.currentOverlay() === element) {
      this.currentOverlay.set(null);
      this.currentOpenMode = null;
    }
  }

  closeAll(): void {
    const current = this.currentOverlay();
    if (current) {
      current.hidePopover();
      this.currentOverlay.set(null);
      this.currentOpenMode = null;
    }
  }
}
